/**
* reducers for the profile
*
* Created by Min on 19/06/18
*/

import C from '../constants'

const initState = {
    data: {},
    isEditing: false,
    isLoading: false,
    errors: [],
}

export const profileState = (state = initState, action) => {

    switch(action.type) {

        case C.SET_PROFILE_LOADER:
            return {
                ...state,
                isLoading: action.payload
            }

        case C.EDIT_PROFILE:
            return {
                ...state,
                isEditing: action.payload
            }

        case C.SET_PROFILE_DATA:
            return {
                ...state,
                data: action.payload
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/profileReducers.js